import apartments from 'shared/assets/img/products/apartments.png';
import balloon_flight from 'shared/assets/img/products/balloon_flight.png';
import bicycle from 'shared/assets/img/products/bicycle.png';
import black_caviar from 'shared/assets/img/products/black_caviar.png';
import car from 'shared/assets/img/products/car.png';
import chocolate_alenka from 'shared/assets/img/products/chocolate_alenka.png';
import fruits from 'shared/assets/img/products/fruits.png';
import home_cinema from 'shared/assets/img/products/home_cinema.png';
import house from 'shared/assets/img/products/house.png';
import lamba_car from 'shared/assets/img/products/lamba_car.png';
import laptop from 'shared/assets/img/products/laptop.png';
import lays from 'shared/assets/img/products/lays.png';
import movie_tickets from 'shared/assets/img/products/movie_tickets.png';
import phone from 'shared/assets/img/products/phone.png';
import ps4 from 'shared/assets/img/products/ps4.png';
import rolex_watches from 'shared/assets/img/products/rolex_watches.png';
import sber_boom from 'shared/assets/img/products/sber_boom.png';
import scooter from 'shared/assets/img/products/scooter.png';
import silver_ring from 'shared/assets/img/products/silver_ring.png';
import skateboard from 'shared/assets/img/products/skateboard.png';
import space_flight from 'shared/assets/img/products/space_flight.png';
import tamagotchi from 'shared/assets/img/products/tamagotchi.png';
import tiffany from 'shared/assets/img/products/tiffany.png';
import tropical_holidays from 'shared/assets/img/products/tropical_holidays.png';
import tickets from 'shared/assets/img/products/tickets.png';

export const images: any = {
    apartments: apartments,
    balloon_flight: balloon_flight,
    bicycle: bicycle,
    black_caviar: black_caviar,
    car: car,
    chocolate_alenka: chocolate_alenka,
    fruits: fruits,
    home_cinema: home_cinema,
    house: house,
    lamba_car: lamba_car,
    laptop: laptop,
    lays: lays,
    movie_tickets: movie_tickets,
    tickets: tickets,
    phone: phone,
    ps4: ps4,
    rolex_watches: rolex_watches,
    sber_boom: sber_boom,
    scooter: scooter,
    silver_ring: silver_ring,
    skateboard: skateboard,
    space_flight: space_flight,
    tamagotchi: tamagotchi,
    tiffany: tiffany,
    tropical_holidays: tropical_holidays,
}
